var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container mt-12"},[_c('MaintainanceMode'),_c('ReadOnlyMode',{staticClass:"mt-12"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }